import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { PhysicianByNpiQuery, PhysicianByNpiQueryVariables } from '@/shared/api';
import PHYSICIAN_BY_NPI_QUERY from '../queries/physicianByNpi';

/**
 * Looks up a physician by NPI number while a study or facility form is filled in. Runs the physicianByNpi query and throws the first GraphQL error only when no physician came back.
 *
 * @param npi - National Provider Identifier to look up.
 * @returns A promise resolving to the matching physician.
 */
const fetchPhysicianByNpi = async (npi: string) => {
  const client = createClient();
  const result = await client.query<PhysicianByNpiQuery, PhysicianByNpiQueryVariables>({
    query: PHYSICIAN_BY_NPI_QUERY,
    variables: {
      npi,
    },
  });
  const { data, errors } = result;
  const { physicianByNpi } = data;
  if (_.isNil(physicianByNpi) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return physicianByNpi;
};

export default fetchPhysicianByNpi;
